/**
 * Modulo de Utils
 * @author jkudla
 */
Utils = {
  // extender un object con otro, sobrescribe los properties que se llaman
  // igual
  extend: function (dest) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function (source) {
      Object.keys(source).forEach(function (key) {
        dest[key] = source[key];
      });
    });
    return dest;
  },
  //copia solo las propiedades que existe en el objeto de destino
  copy: function (dest, source) {
    if (typeof source === "object") {
      $.each(source, function (index, p) {
        if (dest.hasOwnProperty(index)) {
          dest[index] = p;
        }
      });
    }
    return dest;
  },

  // hacer la llamada ajax con JSON GET
  doAjax: function (params, _url) {
    return $.ajax({
      url: _url,
      dataType: 'json',
      data: params,
      cache: false,
      error: function (jqXHR, textStatus, errorThrown) {
        Console.log(textStatus);
      }
    });
  },

  // hacer la llamada ajax con JSON POST
  doAjaxPOST: (params, _url) => {
    return $.ajax({
      url: _url,
      type: 'POST',
      dataType: 'json',
      data: params,
      cache: false,
      error: (jqXHR, textStatus, errorThrown) => {
        console.log(textStatus);
      }
    });
  },
  //buscar en un array de objetos a un valor
  findBy: function (obj, key, val) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) {
        continue;
      }
      if (typeof obj[i] == 'object') {
        objects = objects.concat(Utils.findBy(obj[i], key, val));
      } else if (i == key && obj[key] == val) {
        objects.push(obj);
      }
    }
    return objects;
  },

  //buscar en un array de objetos la etiqueta ESTUDI
  findByEstudi: function (obj) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) {
        continue;
      }
      if (typeof obj[i] === 'object') {
        objects = objects.concat(Utils.findByEstudi(obj[i]));
      } else {
        if (obj.tipusNode === 'ESTUDI') {
          objects.push(obj);
        }
      }
    }
    return objects;
  },

  hiHaFormacioProfessional: function (ariFilter) {
    for (var index in ariFilter) {
      var node = ariFilter[index];
      if (node.tipus != null && node.tipus.codi === "CFP") {
        return true;
      }
    }
    return false;
  },

  getURLEaCParameters: function (absoluteUrl) {
    // alert("CERCA");
    // var url = $location.path().split('/');
    // $scope.firstParameter = url[2];
    // $scope.secondParameter = url[3];
    var listUrlParamns = absoluteUrl.split("?");
    var listParams = listUrlParamns[1].split("&");
    var obj = {};
    var param;
    var i;
    for (i in listParams) {
      if (listParams[i] === "") {
        continue;
      }

      param = listParams[i].split("=");
      obj[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
    }
    return obj;
  },

  getValue: function (params, type) {
    var valueList = [];

    angular.forEach(params, function (value, key) {
      if (key === type) {
        valueList = value;
      }
    })

    return valueList;
  },

  //buscar en un array de objetos a un valor
  findByNomEnsenyament: function (obj, key, val) {
    var objects = [];
    for (var i in obj) {
      if (!obj.hasOwnProperty(i)) {
        continue;
      }
      if (typeof obj[i] == 'object') {
        objects = objects.concat(Utils.findByNomEnsenyament(obj[i], key, val));
      } else if (i == key && obj[key] == val) {
        objects.push(obj);
      }
    }
    return objects;
  }

};

/**
 * Method to get the params from the URL
 */
//TODO Implementarlo al Utils
function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }
}

